// This is a necessary polyfil for async/await. Frontend-platform relies on it
import 'regenerator-runtime/runtime';
import { mergeConfig } from '@edx/frontend-platform';
import {
  configure as configureAuth,
  AxiosJwtAuthService,
  getAuthenticatedHttpClient,
} from '@edx/frontend-platform/auth';

import { getLoggingService } from '@edx/frontend-platform/logging';

import {
  configure as configureAnalytics,
  SegmentAnalyticsService,
} from '@edx/frontend-platform/analytics';
import { configure as configureI18n } from '@edx/frontend-platform/i18n';

const isBrowser = typeof window !== 'undefined';

if (isBrowser) {
  const config = {
    BASE_URL: process.env.GATSBY_SITE_DOMAIN,
    LMS_BASE_URL: process.env.GATSBY_LMS_DOMAIN,
    LOGOUT_URL: `${process.env.GATSBY_LMS_DOMAIN}/logout`,
    REFRESH_ACCESS_TOKEN_ENDPOINT: `${process.env.GATSBY_LMS_DOMAIN}/login_refresh`,
    ACCESS_TOKEN_COOKIE_NAME: process.env.GATSBY_ACCESS_TOKEN_COOKIE_NAME,
    CSRF_TOKEN_API_PATH: process.env.GATSBY_CSRF_TOKEN_API_PATH,
    AUTHN_ALGOLIA_APP_ID: process.env.GATSBY_ALGOLIA_APP_ID,
    AUTHN_ALGOLIA_SEARCH_API_KEY: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
    ON_BOARDING_ALGOLIA_APP_ID: process.env.GATSBY_ALGOLIA_APP_ID,
    ON_BOARDING_ALGOLIA_SEARCH_API_KEY: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
    ACTIVATION_EMAIL_SUPPORT_LINK:
      process.env.GATSBY_AUTHN_ACTIVATION_EMAIL_SUPPORT_LINK,
    TOS_AND_HONOR_CODE: process.env.GATSBY_AUTHN_TOS_AND_HONOR_CODE,
    PRIVACY_POLICY: process.env.GATSBY_AUTHN_PRIVACY_POLICY,
    INFO_EMAIL: process.env.GATSBY_AUTHN_INFO_EMAIL,
    LOGIN_ISSUE_SUPPORT_LINK: process.env.GATSBY_AUTHN_LOGIN_ISSUE_SUPPORT_LINK,
    SEGMENT_KEY: process.env.GATSBY_AUTHN_SEGMENT_KEY,
    ONBOARDING_COMPONENT_ENV: process.env.GATSBY_ENVIRONMENT,
    PASSWORD_RESET_SUPPORT_LINK:
      process.env.GATSBY_AUTHN_PASSWORD_RESET_SUPPORT_LINK,
  };

  mergeConfig(config);
  configureI18n({ config, messages: [], loggingService: getLoggingService() });
  configureAuth(AxiosJwtAuthService, {
    config,
    loggingService: getLoggingService(),
  });
  configureAnalytics(SegmentAnalyticsService, {
    config,
    loggingService: getLoggingService(),
    httpClient: getAuthenticatedHttpClient(),
  });
}

export default isBrowser;
